const config = {
  urlRootSocial: "//moneymakerpt.com/pages/social",
  urlRootTour: "//moneymakerpt.com/pages/tour-section",
  classBodyTour: "tour-section",
  classBodySocial: "social-section",
};
/*
let logoTour = `<a href=${config.urlRootTour} class="site-header__logo-image site-header__logo-image--centered">
<img class="js main_logo" src="//moneymakerpt.com/cdn/shop/files/mm-tour-logo_300x300.png?v=1714259191" srcset="//moneymakerpt.com/cdn/shop/files/mm-tour-logo_300x300.png?v=1714259191 1x, //moneymakerpt.com/cdn/shop/files/mm-tour-logo_300x300@2x.png?v=1714259191 2x" loading="lazy" width="1422" height="1500" alt="Moneymaker Poker Tour" style="max-width: 110px">
</a>`;
let logoSocial = `<a href=${config.urlRootSocial} class="site-header__logo-image site-header__logo-image--centered">
<img class="js main_logo" src="//moneymakerpt.com/cdn/shop/files/mm-social-logo_300x300.png?v=1714259168" srcset="//moneymakerpt.com/cdn/shop/files/mm-social-logo_300x300.png?v=1714259168 1x, //moneymakerpt.com/cdn/shop/files/mm-social-logo_300x300@2x.png?v=1714259168 2x" loading="lazy" width="1422" height="1500" alt="Moneymaker Poker Tour" style="max-width: 110px">
</a>`; */

let logoTour = `
<img class="js main_logo" src="//moneymakerpt.com/cdn/shop/files/mm-tour-logo_300x300.png?v=1714259191" srcset="//moneymakerpt.com/cdn/shop/files/mm-tour-logo_300x300.png?v=1714259191 1x, //moneymakerpt.com/cdn/shop/files/mm-tour-logo_300x300@2x.png?v=1714259191 2x" loading="lazy" width="1422" height="1500" alt="Moneymaker Poker Tour" style="max-width: 110px">
`;
let logoSocial = `
<img class="js main_logo" src="//moneymakerpt.com/cdn/shop/files/mm-social-logo_300x300.png?v=1714259168" srcset="//moneymakerpt.com/cdn/shop/files/mm-social-logo_300x300.png?v=1714259168 1x, //moneymakerpt.com/cdn/shop/files/mm-social-logo_300x300@2x.png?v=1714259168 2x" loading="lazy" width="1422" height="1500" alt="Moneymaker Poker Tour" style="max-width: 110px">
`;

const pagesTour = [
  "/pages/tour-section", //home-tour
  "/pages/moneymaker-tour-palm-beach-kennel-club-may-10th-24th",
  "/blogs/moneymaker-live-updates",
  "/blogs/moneymaker-events",
  "/pages/poker-tour-sponsors",
  "/collections/all-moneymaker-apparel",
  "/pages/about-chris",
  "/pages/contact",
];

const pagesSocial = ["/pages/social", "/pages/social-locations"];

document.addEventListener("DOMContentLoaded", loadCustomJs);

function loadCustomJs() {
  let nodeMenu = document.querySelector(".nav-bar__linklist");
  let nodeMenuMovil = document.querySelector("#MobileNav");
  let nodeLogo = document.querySelector(".site-header__logo-image");
  let itemsToDeleteTour = 1;
  let itemsToDeleteSocial = 8;
  let itemsMenu;
  let itemsMenuMovil;

  function addLogoTourAndMenu() {
    document.body.classList.add(`${config.classBodyTour}`);
    nodeLogo ? (nodeLogo.innerHTML = logoTour) : null;

    itemsMenu = Array.from(nodeMenu.children).slice(-itemsToDeleteTour);
    itemsMenu.forEach((itemMenu) => itemMenu.remove());

    itemsMenuMovil = Array.from(nodeMenuMovil.children).slice(
      -itemsToDeleteTour
    );
    itemsMenuMovil.forEach((itemMenu) => itemMenu.remove());
  }

  function addLogoSocialAndMenu() {
    document.body.classList.add(`${config.classBodySocial}`);
    nodeLogo ? (nodeLogo.innerHTML = logoSocial) : null;

    itemsMenu = Array.from(nodeMenu.children).slice(0, itemsToDeleteSocial);
    itemsMenu.forEach((itemMenu) => itemMenu.remove());

    itemsMenuMovil = Array.from(nodeMenuMovil.children).slice(
      0,
      itemsToDeleteSocial
    );
    itemsMenuMovil.forEach((itemMenu) => itemMenu.remove());
  }

  try {
    for (let index = 0; index < pagesTour.length; index++) {
      if (window.location.pathname === pagesTour[index]) {
        addLogoTourAndMenu();
        if (window.location.pathname === "/pages/tour-section") {
          document.body.classList.add("home-tour");
        }
        break;
      }
    }

    for (let index = 0; index < pagesSocial.length; index++) {
      if (window.location.pathname === pagesSocial[index]) {
        addLogoSocialAndMenu();
        break;
      }
    }
    if (window.location.pathname.includes("/blogs/")) {
      addLogoTourAndMenu();
    }
  } catch (error) {
    console.log("loadCustomJs:", error);
  }
}
